import React, { useCallback, useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const KEY = 'tagws-dash-refresh-min';
const RATES = [1, 3, 5, 10];
const hhmm = (d) => d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

// Soft refresh for a dashboard: every N minutes (user's choice, default 3) plus a manual button.
export function DashRefresh({ onRefresh, testid = 'tagws-dash-refresh', dark = false }) {
  const [min, setMin] = useState(() => (RATES.includes(Number(localStorage.getItem(KEY))) ? Number(localStorage.getItem(KEY)) : 3));
  const [busy, setBusy] = useState(false);
  const [at, setAt] = useState(() => new Date());
  const run = useCallback(async () => {
    setBusy(true);
    try { await onRefresh?.(); setAt(new Date()); } catch { /* the next round tries again */ } finally { setBusy(false); }
  }, [onRefresh]);
  const ref = useRef(run); ref.current = run;
  useEffect(() => {
    const t = setInterval(() => { if (!document.hidden) ref.current(); }, min * 60000);
    return () => clearInterval(t);
  }, [min]);
  const pick = (v) => { setMin(v); localStorage.setItem(KEY, String(v)); };
  const box = dark ? 'border-white/15 bg-white/10 text-white' : 'border-border bg-background text-foreground';
  return (
    <div className={`inline-flex h-9 items-center gap-1 rounded-xl border px-1 text-xs ${box}`} data-testid={testid}>
      <button type="button" onClick={run} disabled={busy} title={`Refresh now · last updated ${hhmm(at)}`} className={`inline-flex h-7 items-center gap-1.5 rounded-lg px-2 font-semibold disabled:opacity-60 ${dark ? 'hover:bg-white/15' : 'hover:bg-secondary'}`} data-testid={`${testid}-now`}>
        <RefreshCw size={13} className={busy ? 'animate-spin' : ''} /> <span data-testid={`${testid}-at`}>{busy ? 'Refreshing…' : hhmm(at)}</span>
      </button>
      <select value={min} onChange={(e) => pick(Number(e.target.value))} title="Auto refresh every" className={`h-7 rounded-lg border-0 bg-transparent pr-1 text-xs ${dark ? 'text-white [&>option]:text-slate-900' : 'text-foreground'}`} data-testid={`${testid}-rate`}>
        {RATES.map((r) => <option key={r} value={r}>Every {r} min</option>)}
      </select>
    </div>
  );
}
